// 이용약관
export const TERMS_OF_SERVICE =
	'http://teamfore.notion.site/15c4abba6dbc4c788511d7466ca2a801?pvs=25';
